export default __webpack_public_path__ + "static/media/tituloEN.807d5757.png";